import type { OrderPrices, OrderPricesWithUnknownDeliveryPrice } from "../OrderPrices.js";

export function hasKnownDeliveryPrice(
	price: Pick<OrderPricesWithUnknownDeliveryPrice, "deliveryPrice" | "deliveryPriceWithoutTax">,
): price is OrderPrices {
	const invalidValues: OrderPricesWithUnknownDeliveryPrice["deliveryPrice"][] = [null, "unreachable"];
	return !invalidValues.includes(price.deliveryPrice) && !invalidValues.includes(price.deliveryPriceWithoutTax);
}
